module.exports = __webpack_public_path__ + "img/vaccine-types-image-right.397c4a9f.png";